export default __webpack_public_path__ + "static/media/baquetas.bcb254f4.png";